import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { useApi } from '@src/app/context/Api';
import { ActionPathsTable } from '@src/entities/ActionPath/ui/components/tables/ActionPaths';
import { CreateMenuButton } from '@src/features/ActionPaths/Creation/components/buttons/CreateMenu';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { ToggleSwitch } from '@uhg-abyss/web/ui/ToggleSwitch';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';

/**
 * Page: List
 *
 * Provides the user with a screen listing the existing action paths.
 *
 * @returns {Element}
 * @constructor
 */
export function List() {
  const [showAll, setShowAll] = useState(false);

  const { clearApiCache, useApiQuery } = useApi('ActionPath');

  const [ListActionPaths, { data, error, isFetching, isLoading, refetch }] = useApiQuery('ListActionPaths');

  /**
   * Invalidate the query cache when the showAll state changes.
   */
  useEffect(() => {
    clearApiCache([{ apiKey: 'ActionPath', queryKeys: ['ListActionPaths'] }]);
  }, [showAll]);

  return (
    <ErrorHandler location="src/pages/private/ActionPaths/List/List.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <Flex alignItems="center" direction="row">
              <Heading offset={0}>Action Paths</Heading>
              <div
                style={{
                  marginLeft: themeConfiguration?.theme?.space?.md,
                }}
              >
                <CreateMenuButton />
              </div>
            </Flex>
          </Grid.Col>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            {!showAll && (
              <ActionPathsTable
                error={error}
                headerLeft={
                  <ToggleSwitch
                    isChecked={showAll}
                    label="Show All Action Paths"
                    onChange={(event) => {
                      return setShowAll(event?.target?.checked);
                    }}
                  />
                }
                isLoading={isLoading || isFetching}
                refetch={refetch}
                requestArgs={{ page: 0, size: 25, sort: 'lastModifiedDate,desc', statusList: ['ACTIVE'] }}
                requestFunction={ListActionPaths}
                requestKey="ListActionPaths"
                rows={data?.content || []}
                totalPages={data?.totalPages || 1}
                totalRecords={data?.totalElements || 0}
              />
            )}

            {showAll && (
              <ActionPathsTable
                error={error}
                headerLeft={
                  <ToggleSwitch
                    isChecked={showAll}
                    label="Show All Action Paths"
                    onChange={(event) => {
                      return setShowAll(event?.target?.checked);
                    }}
                  />
                }
                isLoading={isLoading || isFetching}
                refetch={refetch}
                requestArgs={{ page: 0, size: 25, sort: 'lastModifiedDate,desc' }}
                requestFunction={ListActionPaths}
                requestKey="ListActionPaths"
                rows={data?.content || []}
                totalPages={data?.totalPages || 1}
                totalRecords={data?.totalElements || 0}
              />
            )}
          </Grid.Col>
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
